import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GMapModule, OverlayPanelModule } from 'primeng/primeng';
import { SharedModule } from '../shared/shared.module';
import { FooterAboutComponent } from './footer-about/footer-about.component';
import { FooterPrivacyComponent } from './footer-privacy/footer-privacy.component';
import { FooterSupportComponent } from './footer-support/footer-support.component';
import { FooterTermsComponent } from './footer-terms/footer-terms.component';

@NgModule({
    declarations: [
        FooterAboutComponent,
        FooterPrivacyComponent,
        FooterSupportComponent,
        FooterTermsComponent,
    ],
    imports: [
        FormsModule,
        SharedModule,
        OverlayPanelModule,
        GMapModule
    ],
    exports: [
        FooterPrivacyComponent,
        FooterAboutComponent,
        FooterSupportComponent,
        FooterTermsComponent,
        FooterPrivacyComponent,
    ]
})
export class FooterLinksModule {

}
